const BASE64_TAG = 'base64';
const TEXT_HTML = 'text/html';
const BLOCKED_ELEMENTS =
  'base,embed,form,frame,frameset,iframe,input,link,meta,object,script,template';
const URL_ATTRIBUTES = new Set([
  'action',
  'formaction',
  'href',
  'src',
  'xlink:href',
]);
const domParser = new DOMParser();
const xmlSerializer = new XMLSerializer();

const hasExecutableProtocol = (value) => {
  const normalizedValue = Array.from(value)
    .filter((character) => character.charCodeAt(0) > 32)
    .join('')
    .toLowerCase();

  return (
    // This literal is matched as untrusted input; it is never evaluated.
    // eslint-disable-next-line no-script-url
    normalizedValue.startsWith('javascript:') ||
    normalizedValue.startsWith('vbscript:') ||
    normalizedValue.startsWith('data:')
  );
};

const sanitizeNotificationHtml = (htmlAsString) => {
  if (typeof htmlAsString !== 'string') {
    return htmlAsString;
  }

  const document = domParser.parseFromString(htmlAsString, TEXT_HTML);

  Array.from(document.querySelectorAll(BLOCKED_ELEMENTS)).forEach((element) => {
    element.parentNode.removeChild(element);
  });

  Array.from(document.querySelectorAll('*')).forEach((element) => {
    Array.from(element.attributes).forEach((attribute) => {
      const attributeName = attribute.name.toLowerCase();

      if (
        attributeName.startsWith('on') ||
        attributeName === 'srcdoc' ||
        (URL_ATTRIBUTES.has(attributeName) &&
          hasExecutableProtocol(attribute.value))
      ) {
        element.removeAttribute(attribute.name);
      }
    });
  });

  return xmlSerializer.serializeToString(document);
};

/**
 * This helper function is to be used with notifications
 * It will take an html string and convert any/all
 * <base64>{base64 data here}</base64> tags to its equivalent
 *
 * So it will turn this:
 *   <base64>dGVzdCBlbW9qaSDwn5iA8J+Ygw==</base64>
 * into this:
 *   <base64>test emoji 😀😃</base64>
 *
 * @param htmlAsString - html string with base64 encoded elements
 * @returns htmlAsString - html string with base64 decoded elements
 */
const decodeEmoji = (htmlAsString) => {
  try {
    const document = domParser.parseFromString(htmlAsString, TEXT_HTML);
    const base64HtmlTags = document.getElementsByTagName(BASE64_TAG);
    const base64TagCount = base64HtmlTags.length;

    for (let i = 0; i < base64TagCount; i++) {
      const element = base64HtmlTags.item(i);
      const decoded = atob(element.textContent);

      element.textContent = decodeURIComponent(escape(decoded));
    }

    return base64TagCount
      ? xmlSerializer.serializeToString(document)
      : htmlAsString;
  } catch (e) {
    // It is possible the data from database has an issue, let iframe handle
    return htmlAsString;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const addDerived = (r) => {
  r.renderedMsgDecoded = sanitizeNotificationHtml(decodeEmoji(r.renderedMsg));

  return r;
};
